import { useQuery } from 'react-query';
import { useFetch } from '../context/FetchProvider';

/**
 * Hook to learnify text.
 */
export const useLearnifyText = (text: string, enabled: boolean) => {
  const { post } = useFetch();

  const { data: result, isLoading } = useQuery(
    ['learnify-text', text],
    async () => {
      const { data } = await post<
        {
          result: string;
        },
        { text: string }
      >(`/learnifyText`, { text });

      return data?.result;
    },
    {
      enabled: !!text && enabled,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      staleTime: Infinity,
    },
  );

  return { result: result || text, isLoading };
};
